import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ToasterService } from "./toaster.service";
import { ToasterComponent } from "./toaster.component";

@Component({
    selector: 'app-toaster-container',
    template: `
    @for (toaster of toasters; track toaster; let i = $index) {
      <app-toaster
        [toaster]="toaster"
        [top]="getTopPosition(i)"
        (close)="hideToaster($event)">
      </app-toaster>
    }
    `,
    styles: [``],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ToasterComponent]
})
export class ToasterContainerComponent implements OnInit {
    toasters: any[] = [];

    constructor(private toasterService: ToasterService) {}

    ngOnInit() {
        this.toasterService.toastersSubject.subscribe(toasters => {
            this.toasters = toasters;
        });
    }

    getTopPosition(index: number): string {
        return `${50 + (index * 95)}px`;
    }

    hideToaster(id: number) {
        this.toasterService.hideToaster(id);
    }
}
